import React from 'react'
import routesConfig from '@mindfulchefuk/config/routesConfig'
import { Link } from '@mindfulchefuk/design-system'
import { CHECKOUT_ERROR } from '@mindfulchefuk/features/Notifications/constants'

export const generateCheckoutErrorConfig = (error?: Error) => ({
  title: CHECKOUT_ERROR,
  text:
    error instanceof Error && error.message ? (
      error.message
    ) : (
      <>
        Please try again or{' '}
        <Link
          color="inherit"
          target="_blank"
          href={`${routesConfig.contactus.pathname}#contactus`}
        >
          contact our Customer Care team
        </Link>
      </>
    ),
})
